import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Tag } from "primereact/tag";
import React from "react";
import { formatDate2, formatDateTime } from "../../../algorithms/date";

export default function StorageRentalTable({
  className,
  headers = [
    {
      header_name: "Column 1",
      header_key: "column1",
    },
    {
      header_name: "Column 2",
      header_key: "column2",
    },
  ],
  items = [
    {
      column1: "Column 2",
      column2: "Column 2",
    },
  ],
  isNative = false,
  children,
  linkName,
  linkBody,
  fieldId,
  actionColumn,
  bottomAction,
  multiItemField,
  dt,
  showTransactionNumber,
  dateRange,
}) {
  console.log({ items, headers });
  var currentDate = new Date();
  //date formatter
  const formatDate = (inputDate) => {
    if (inputDate == null) {
      return "";
    }

    // Parse the UTC date string directly
    const date = new Date(inputDate);

    // Format the date to Philippine Time (UTC+8)
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
      timeZone: "Asia/Manila",
    };

    return date.toLocaleString("en-US", options);
  };

  // rowColors to be used when backend is done
  const rowClassName = (rowData) => {
    if (rowData.transActStatus === 1) {
      return "bg-green-300 border border-black";
    } else if (rowData.transActStatus === 2) {
      return "bg-red-300 border border-black";
    }
    return "border border-black";
  };
  const withLinkTemplate = (rowData) => {
    if (Array.isArray(fieldId)) {
      return (
        <a
          className={"text-component-blueTextColor"}
          href={`${process.env.REACT_APP_BASE_ENVIRONMENT}${linkBody}/${
            rowData[fieldId[0]]
          }/${rowData[fieldId[1]]}`}
          target="_blank"
        >
          {rowData[linkName]}
        </a>
      );
    } else {
      return (
        <a
          className={"text-component-blueTextColor"}
          href={`${process.env.REACT_APP_BASE_ENVIRONMENT}${linkBody}/${rowData[fieldId]}`}
          target="_blank"
        >
          {rowData[linkName]}
        </a>
      );
    }
  };

  const multiItemTemplate = (rowData) => {
    return (
      <div>
        {Object.values(rowData[multiItemField]).map((element) => {
          return (
            <div className="border-b-2 border-black-500">
              <p>{element}</p>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <DataTable
      paginatorTemplate="CurrentPageReport RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
      currentPageReportTemplate="Rows per page"
      paginator
      paginatorRight
      rowsPerPageOptions={[10, 20, 50]}
      value={items}
      rows={10}
      sortMode="multiple"
      sortField="name"
      sortOrder={1}
      stripedRows
      showGridlines
      exportFilename={`Storage Rental Fees Report (${dateRange})`}
      tableStyle={{
        minWidth: "50rem",
        borderWidth: 2,
        borderColor: "#E6E6E6",
      }}
      rowClassName={rowClassName}
      removableSort
      ref={dt}
      header={`Total Results: ${items.length}`}
      emptyMessage={"No transactions found"}
      cellSelection={true}
      onCellClick={(e) => {
        if (e.rowData.packageId != null && e.field == "packageId") {
          window.open(
            `/operator/admin/view-package-history/${e.rowData.packageId}/${e.rowData.recipientId}`,
            "_blank"
          );
        }
        if (
          e.field == "recipientMobile" &&
          e.rowData.recipientId != null &&
          e.field == "recipientMobile"
        ) {
          window.open(
            `/operator/admin/locker-user-accounts/user-profile-page/${e.rowData.recipientId}`,
            "_blank"
          );
        }
        if (
          e.field == "senderMobile" &&
          e.rowData.senderId != null &&
          e.field == "senderMobile"
        ) {
          window.open(
            `/operator/admin/locker-user-accounts/user-profile-page/${e.rowData.senderId}`,
            "_blank"
          );
        }
      }}
    >
      {headers.map((data, key) => {
        if (data.header_key == "blank") {
          return (
            <Column
              field={data.header_key}
              header={data.header_name}
              style={{ display: "none" }}
            ></Column>
          );
        }

        if (data.header_key == "status") {
          return (
            <Column
              field={data.header_key}
              header={data.header_name}
              headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
              sortable
              body={(rowData) => (
                <Tag
                  value={
                    rowData[data.header_key] === "1"
                      ? "Successful"
                      : rowData[data.header_key] === "2"
                      ? "Failed"
                      : "Refunded"
                  }
                  severity={
                    rowData[data.header_key] === "1"
                      ? "success"
                      : rowData[data.header_key] === "2"
                      ? "danger"
                      : "warning"
                  }
                  className="text-secondary-purpleGray"
                />
              )}
            ></Column>
          );
        }

        if (data.header_key == "duplicate") {
          return (
            <Column
              field={data.header_key}
              header={data.header_name}
              // headerClassName={`${showTransactionNumber ? "" : "hidden"}`}
              // className={`${showTransactionNumber ? "" : "hidden"}`}
              headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
              sortable
              body={(rowData) => {
                return (
                  <Tag
                    value={rowData.duplicate ? "Yes" : "No"}
                    // severity={rowData.duplicate ? "success" : "warning"}
                    // text-secondary-purpleGray
                    className={`${
                      rowData.duplicate
                        ? "bg-green-200 text-green-900"
                        : "bg-red-200 text-red-900"
                    }`}
                  />
                );
              }}
            ></Column>
          );
        }

        if (data.header_key == "paymentId") {
          return (
            <Column
              field={data.header_key}
              header={data.header_name}
              headerClassName={`${showTransactionNumber ? "" : "hidden"}`}
              className={`${showTransactionNumber ? "" : "hidden"}`}
              headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
              sortable
            ></Column>
          );
        }

        if (
          data.header_key == "paymentAmount" ||
          data.header_key == "transactionFee" ||
          data.header_key == "excessFee"
        ) {
          return (
            <Column
              field={data.header_key} // Ensure this matches a key in your row data
              header={data.header_name}
              headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
              sortable
              body={(rowData) => (
                <div>
                  {rowData[data.header_key] && rowData.paymentCurrency === "PHP"
                    ? `₱ ${rowData[data.header_key]?.toFixed(2)}`
                    : rowData[data.header_key]?.toFixed(2)}
                </div>
              )}
              // body={(rowData) => <div>₱ {rowData[data.header_key]}</div>}
            ></Column>
          );
        }

        if (
          data.header_key === "storageDuration" ||
          data.header_key === "lengthOfStay"
        ) {
          return (
            <Column
              field={data.header_key} // Ensure this matches a key in your row data
              header={data.header_name}
              headerStyle={{
                width: "3rem",
                backgroundColor: "#FECD08",
              }}
              sortable
              body={(rowData) => (
                <div>
                  {rowData[data.header_key]
                    ? `${rowData[data.header_key]} hours`
                    : "N hours"}
                </div>
              )}
            ></Column>
          );
        }

        if (data.header_key == "unformattedPaymentDate") {
          return (
            <Column
              field={data.header_key} // Ensure this matches a key in your row data
              header={data.header_name}
              exportHeader="Payment Date"
              exportField="unformattedPaymentDate"
              headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
              sortable
              body={(rowData) => (
                <div>{rowData.paymentDate}</div>
                // <div>{formatDate(rowData[data.header_key])}</div> // Call formatDate here
              )}
            ></Column>
          );
        }

        if (linkBody && linkName === data.header_key) {
          return (
            <Column
              field={data.header_key}
              sortable
              header={data.header_name}
              body={withLinkTemplate}
              headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
            ></Column>
          );
        }
        if (data.header_key === multiItemField) {
          return (
            <Column
              sortable
              header={data.header_name}
              body={multiItemTemplate}
              headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
            ></Column>
          );
        }
        if (
          data.header_key == "recipientMobile" ||
          data.header_key == "senderMobile" ||
          data.header_key == "packageId"
        ) {
          return (
            <Column
              field={data.header_key}
              sortable
              className="cursor-pointer hover:text-blue-500"
              header={data.header_name}
              headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
              body={(rowData) => {
                if (data.header_key === "packageId") {
                  return <div>(Storage)</div>;
                } else {
                  return <div>{rowData[data.header_key]}</div>;
                }
              }}
            ></Column>
          );
        } else {
          return (
            <Column
              field={data.header_key}
              sortable
              header={data.header_name}
              headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
            ></Column>
          );
        }
      })}
    </DataTable>
  );
}
